/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForElasticSearch extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForElasticSearch");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForElasticSearch.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForElasticSearch>): ServiceAccountNativeDetailsForElasticSearch {
        let obj = Object.assign(new ServiceAccountNativeDetailsForElasticSearch(), model);
        ServiceAccountNativeDetailsForElasticSearch.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForElasticSearch>): ServiceAccountNativeDetailsForElasticSearch {
        if (!model) return null;
        return ServiceAccountNativeDetailsForElasticSearch.newInstance(<ServiceAccountNativeDetailsForElasticSearch> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForElasticSearch) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForElasticSearch.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForElasticSearch): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForElasticSearch.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
